import { InputNumber } from 'primereact/inputnumber';
import { Slider } from 'primereact/slider';
import React, { useEffect, useState } from 'react';
import { useAppDispatch } from '../../../../hooks/hooks';

interface Props {
    min: number;
    max: number;
    data: string;
    label: string;
    update: (payload: string) => void;
    step?: number;
    minFractionDigits?: number;
    factor?: number;
    disabled?: boolean;
}

export const InputNumberSlider = ({min, max, data, step = 1, minFractionDigits = 0, factor = 1, label, update, disabled}: Props) => {

    const dispatch = useAppDispatch();
    const regex = /^(\d+(\.\d+)*)([a-zA-Z]+)$/;
    const [value, setValue] = useState<number>();
    const [unit, setUnit] = useState<string>();

    useEffect(() => {
        const match = data.match(regex);
        if (match) {
            setValue(Number(match[1])/factor);
            setUnit(match[3]);
        }
    }, [data]);

    return <>{value ? <div className="p-label">
        <b>
            <label>{label}</label>
        </b>
        <br/>
        <div className="flex justify-content-between mt-2">
            <div>{min} {unit}</div>
            <div>{max} {unit}</div>
        </div>
        <InputNumber
            value={value}
            disabled={disabled}
            min={min}
            max={max}
            minFractionDigits={minFractionDigits}
            onValueChange={(e) => {
                if (e.value) {
                    const newValue = String(e.value * factor ?? 0) + unit;
                    // @ts-ignore
                    dispatch(update(newValue));
                }
            }}
        />
        <Slider
            value={value}
            disabled={disabled}
            min={min}
            max={max}
            step={step}
            onChange={(e) => {
                if (typeof e.value === 'number') {
                    const newValue = String(e.value * factor ?? 0) + unit;
                    // @ts-ignore
                    dispatch(update(newValue));
                }
            }}
        />
    </div> : <span>Error</span>} </>
}